<template>
    <div class="w-full bg-gray-200 border border-gray-300 h-4 relative overflow-hidden rounded-md">
        <div
            aria-valuemax="100"
            aria-valuemin="0"
            :aria-valuenow="percentage"
            class="flex h-full rounded transition-300 transition-width"
            :class="backgroundClassName"
            role="progressbar"
            :style="{ width: `${percentage}%` }"
        >
            <span
                class="flex-1 h-full w-full px-1 text-center text-white text-xs"
                v-text="`${percentage}%`"
            />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            percentage: {
                type: Number,
                required: true,
            },
            color: {
                type: String,
                default: 'blue',
                validator: (value) => ['blue', 'green', 'orange', 'red'].includes(value),
            },
        },

        computed: {
            backgroundClassName() {
                switch (this.color) {
                    case 'green':
                        return 'bg-green-500';
                    case 'orange':
                        return 'bg-yellow-500';
                    case 'red':
                        return 'bg-red-500';
                    case 'blue':
                    default:
                        return 'bg-blue-500';
                }
            },
        },
    };
</script>
